import React from 'react';
import { isEmpty } from "../utils";
import Divider from "../Divider";

var DropdownSelectedMenuList = function DropdownSelectedMenuList(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange;

  var handleItemClick = function handleItemClick(e, menuItemValue) {
    e.stopPropagation();
    onChange(e, menuItemValue);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      selected: true,
      onClick: handleItemClick,
      multiselect: true
    });
  }), !isEmpty(children) && /*#__PURE__*/React.createElement(Divider, null));
};

export default DropdownSelectedMenuList;